import { isSupportedLanguage, DEFAULT_LANGUAGE } from "./supportedLanguages";

export const PUBLIC_ROUTE_PATTERNS: string[] = [
  "/",
  "/about",
  "/help",
  "/legal/cookies",
  "/legal/imprint",
  "/legal/liability",
  "/legal/privacy",
  "/newsletter/confirmed",
  "/newsletter/unsubscribed",
  "/newsletter/error",
  "/r/us-west-coast",
  "/r/us-east-coast",
];

export function getLocaleFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/([a-z]{2})(?:\/|$)/);
  if (!match) return null;
  const code = match[1];
  return isSupportedLanguage(code) ? code : null;
}

export function stripLocalePrefix(pathname: string): string {
  const locale = getLocaleFromPath(pathname);
  if (!locale) return pathname;
  const rest = pathname.slice(locale.length + 1);
  return rest === "" || rest === "/" ? "/" : rest;
}

export function buildLocalePath(lang: string, path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const stripped = stripLocalePrefix(normalized);
  return stripped === "/" ? `/${lang}` : `/${lang}${stripped}`;
}

export function detectPreferredLanguage(): string {
  const stored = localStorage.getItem("daynav.language");
  if (stored && isSupportedLanguage(stored)) return stored;

  const navLangs = navigator.languages ?? [navigator.language];
  for (const raw of navLangs) {
    const code = raw.split("-")[0].toLowerCase();
    if (isSupportedLanguage(code)) return code;
  }

  return DEFAULT_LANGUAGE;
}

export function isPublicRoute(pathname: string): boolean {
  const stripped = stripLocalePrefix(pathname);
  return PUBLIC_ROUTE_PATTERNS.includes(stripped);
}
